import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: '103px',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '100vh',
    backgroundColor: STYLE.COLOR.WHITE,
    '@media (max-width: 1024px)': {
      paddingTop: '100px',
      maxWidth: '100%',
      padding: theme.spacing(2),
    },
    '@media (max-width: 768px)': {
      paddingTop: '90px',
      padding: theme.spacing(2),
    },
    '@media (max-width: 600px)': {
      paddingTop: '80px',
    },
    '@media (max-width: 480px)': {
      padding: theme.spacing(2),
      paddingTop: '90px',
    },
  },
  mainHeader: { left: 0 },
  blankBackground: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: STYLE.COLOR.WHITE,
    zIndex: 1,
  },

  // Header styles
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(4),
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
    '@media (max-width: 480px)': {
      gap: '12px',
    },
  },
  headerTitleContainer: {},
  title: {
    fontWeight: 600,
    color: STYLE.COLOR.BLACK,
    fontSize: '32px',
    lineHeight: '39px',
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '30px',
    },
    '@media (max-width: 480px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  projectName: {
    fontWeight: 400,
    color: STYLE.COLOR.TEXT2,
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: 4,
    '@media (max-width: 768px)': {
      fontSize: '14px',
      lineHeight: '24px',
    },
  },
  headerActions: {
    display: 'flex',
    gap: theme.spacing(2),
    '@media (max-width: 768px)': {
      width: '100%',
      justifyContent: 'space-between',
    },
    '@media (max-width: 480px)': {
      gap: theme.spacing(1.5),
    },
  },
  actionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  actionButton: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textDecoration: 'underline',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
  },

  // Tabs styles
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '32px',
    gap: theme.spacing(2),
    '@media (max-width: 960px)': {
      marginBottom: theme.spacing(3),
    },
    '@media (max-width: 480px)': {
      gap: '10px',
    },
  },
  tabs: {
    borderBottom: '0px' + '!important',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: STYLE.COLOR.TEXT1,
      '&.Mui-selected': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
        color: STYLE.COLOR.WHITE,
        '& .custom-count-badge': {
          backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
          color: STYLE.COLOR.ACCENT_PRIMARY,
        },
      },
      '@media (max-width: 768px)': {
        fontSize: '14px',
        minWidth: 'auto',
        padding: theme.spacing(1, 1.5),
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '@media (max-width: 768px)': {
      width: '100%',
      '& .MuiTabs-flexContainer': {
        justifyContent: 'flex-start',
      },
    },
    '@media (max-width: 480px)': {
      overflowX: 'auto',
      '& .MuiTabs-scroller': {
        overflowX: 'auto !important',
      },
    },
  },
  tab: {
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '8px !important',
    marginRight: '16px' + '!important',
    '@media (max-width: 768px)': {
      marginRight: '8px' + '!important',
    },
    '@media (max-width: 480px)': {
      marginRight: '6px' + '!important',
    },
  },
  customTabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  customCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },

  // Workers grid
  workersGrid: {
    marginTop: theme.spacing(2),
    '@media (max-width: 768px)': {
      '& > .MuiGrid-item': {
        paddingTop: '18px !important',
      },
    },
    '@media (max-width: 480px)': {
      '& > .MuiGrid-item': {
        paddingTop: '18px !important',
      },
    },
  },

  // Empty state styles
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    minHeight: '400px',
  },
  emptyStateIcon: {
    fontSize: '64px',
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
  emptyStateTitle: {
    fontSize: '22px',
    lineHeight: '24px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT1,
    marginTop: 12,
    marginBottom: 4,
  },
  emptyStateSubtitle: {
    fontSize: '16px',
    lineHeight: '26px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT2,
    maxWidth: '400px',
  },
  content: {
    paddingBottom: theme.spacing(2),
  },
  paginationWrapper: {
    padding: theme.spacing(2, 0),
    marginTop: '48px',
    marginBottom: '48px',
    '@media (max-width: 768px)': {
      marginTop: '32px',
      marginBottom: '32px',
    },
    '@media (max-width: 480px)': {
      marginTop: '24px',
      marginBottom: '24px',
      '& .MuiPagination-ul': {
        flexWrap: 'nowrap',
        justifyContent: 'center',
      },
    },
  },

  // Dropdown styles for mobile
  tabDropdown: {
    flex: 1 + '!important',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}` + '!important',
    borderRadius: '12px' + '!important',
    justifyContent: 'space-between' + '!important',
    padding: '14px 16px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    fontWeight: 500 + '!important',
    fontSize: '14px' + '!important',
    lineHeight: '100%' + '!important',
  },

  dropdownMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      borderRadius: theme.spacing(1),
      width: '100%',
      padding: '0px 12px',
      marginTop: '8px',
    },
  },

  dropdownMenuItem: {
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    minHeight: '36px' + '!important',
    paddingLeft: '8px' + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
      color: STYLE.COLOR.TEXT2,
      width: '18px',
      height: '18px',
    },
  },
  dropdownItemContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(1),
  },
  dropdownCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },

  // Worker card styles
  workerCard: {
    borderRadius: '12px' + '!important',
    borderWidth: '1px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  uploadNewButton: {
    marginTop: '24px !important',
    marginBottom: '8px !important',
    width: '100%',
  },
  workerHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '12px',
    width: '100%',
  },
  workerHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
    minWidth: 0,
  },
  workerAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    background: STYLE.COLOR.WARNING_LIGHT,
    borderRadius: '50%',
    fontSize: '18px',
    fontWeight: 600,
    color: STYLE.COLOR.TEXT4,
    fontFamily: 'Poppins',
    flexShrink: 0,
  },
  workerInfo: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: '2px',
  },
  workerName: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '22px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '16px',
  },
  workerDate: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  progressContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  progressBar: {
    height: '8px' + '!important',
    borderRadius: '4px' + '!important',
    backgroundColor: STYLE.COLOR.GRAY + '!important',
    flex: 1,
  },
  progressBarFill: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
  },
  progressBarFillError: {
    backgroundColor: STYLE.COLOR.ERROR + '!important',
  },
  progressText: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '32px',
    color: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER,
    minWidth: '35px',
    textAlign: 'right',
  },
  progressTextError: {
    color: STYLE.COLOR.ERROR,
  },
  errorBar: {
    backgroundColor: STYLE.COLOR.ERROR_LIGHTER + '!important',
    padding: '6px 8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '4px',
    marginTop: '12px',
    marginBottom: '12px',
    justifyContent: 'space-between',
  },
  errorBarText: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    color: STYLE.COLOR.ERROR,
  },
  errorBarViewDetails: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  workerDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '12px',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  workerDates: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
  },
  dateItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
  },
  detailLabel: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
  },
  detailValue: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '22px',
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-word',
  },
  detailValueClamp: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  // Actions Menu styles
  actionsMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      borderRadius: 12,
      minWidth: '200px',
      padding: '0px 12px',
    },
  },
  actionsMenuItem: {
    padding: '8px 8px 8px 6px' + '!important',
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
      color: STYLE.COLOR.TEXT2,
      width: '18px',
      height: '18px',
    },
  },
  menuButton: {
    width: '24px',
    height: '24px',
  },

  // Loading and error state styles
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px',
  },
  errorContainer: {
    padding: '20px',
  },
  warningMessage: {
    marginTop: 32,
    marginBottom: 32,
  },
}));

export const useStylesProfileWarningModal = makeStyles((theme: any) => ({
  modal: {
    '& .MuiDialog-paper': {
      width: '560px',
      maxWidth: '100%',
    },
  },
  modalTitle: {
    justifyContent: 'flex-end',
    paddingBottom: '0px !important',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    borderWidth: '0px',
    paddingTop: '0px !important',
    paddingBottom: '16px !important',
    marginTop: -12,
  },
  modalActions: {
    borderWidth: '0px',
    justifyContent: 'center !important',
    paddingBottom: '32px !important',
  },
  imageParent: {
    height: 90,
    width: 90,
  },
  title: {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
    color: STYLE.COLOR.TEXT1,
    textAlign: 'center',
    marginTop: 32,
    marginBottom: 12,
  },
  warningText: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '26px',
    color: STYLE.COLOR.TEXT1,
    whiteSpace: 'pre-line',
  },
  button: {
    minWidth: '184px !important',
  },
  stepName: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
  },
}));

export const useStylesDeleteWorkerModal = makeStyles((theme: any) => ({
  modal: {
    '& .MuiDialog-paper': {
      width: '560px',
      maxWidth: '100%',
    },
  },
  modalTitle: {
    justifyContent: 'flex-end',
    paddingBottom: '0px !important',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    borderWidth: '0px',
    paddingTop: '0px !important',
    paddingBottom: '16px !important',
    marginTop: -12,
  },
  modalActions: {
    borderWidth: '0px',
    justifyContent: 'center !important',
    paddingBottom: '32px !important',
  },
  imageParent: {
    height: 90,
    width: 90,
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px',
    color: STYLE.COLOR.TEXT1,
    textAlign: 'center',
    marginTop: 32,
    marginBottom: 12,
  },
  warningText: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '26px',
    color: STYLE.COLOR.TEXT1,
  },
  workerName: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
  },
  button: {
    minWidth: '140px !important',
  },
}));
